import type { AvaliacaoDeliveryItem } from "../../../services/avaliacaoDelivery"

export type AvaliacaoDeliveryModel = {
    avaliacoes: AvaliacaoDeliveryItem[]
    total: number
    media: number | null
    nps: number | null
    inicioMs: number
    fimMs: number
}

function inicioPadrao(): number {
    const d = new Date()
    d.setMonth(d.getMonth() - 3)
    return d.getTime()
}

export const AvaliacaoDeliveryInicial: AvaliacaoDeliveryModel = {
    avaliacoes: [],
    total: 0,
    media: null,
    nps: null,
    inicioMs: inicioPadrao(),
    fimMs: Date.now(),
}
